import { logError } from '~/utils/log'

const ImageValidator = (prop, name) => {
  const hasImageUrl = prop.hasOwnProperty('url')
  const isValidImageUrl = typeof prop.url === 'string' ? true : false
  const hasValidImageObject = hasImageUrl && isValidImageUrl

  if (!hasValidImageObject) {
    logError(`The image object for ${name} is not valid because it doesn't have the "url" attribute.`, prop)

    return false
  }

  return true
}

export default ImageValidator
